<div id="" class="tableBox animated fadeIn faster" *ngIf="dataTable.length > 1">
    <!--  -->
    <kendo-tabstrip (tabSelect)="onTabSelect($event)">

        <kendo-tabstrip-tab *ngFor="let data of dataTable;let i=index" [disabled]='data.disabled'
            [title]="data.title | translate" [selected]="i == selected">

            <ng-template kendoTabContent *ngIf="!isLoading">

                <kendo-grid [pageSize]="pageSize" [skip]="skip" [pageable]="pageable" class="variasPestanas"
                    [selectable]="true" [data]="data.gridView" (cellClick)="selectRow($event)"
                    height="{{dataTable[0].height}}" (pageChange)="pageChange($event)"
                    [sortable]="sortable" [sort]="sort" [resizable]='true'
                    (sortChange)="sortChange($event)" [rowClass]="rowCallback">
                    <ng-template kendoGridNoRecordsTemplate>
                        {{ 'genericos.messagesKendo.noDataAvailableNo' | translate }}
                    </ng-template>

                    <kendo-grid-column *ngFor="let th of data.th;let i=index" field="{{data.fields[i]}}"
                        title="{{ th | translate }}" width="{{data.width[i]}}" format="{{data.format[i]}}">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <a href="#" data-toggle="tooltip" data-placement="top" title="{{ th | translate }}">
                                {{th | translate}}
                            </a>
                        </ng-template>

                        <ng-template kendoGridCellTemplate let-dataItem let-column="column">

                            <div title="{{ labelFunction(dataItem, data.fields[i])}}"
                                *ngIf="(data.fields[i].indexOf(';') != -1) && (data.fields[i] != 'IsIntegratedEQ0093') && (data.fields[i] !== 'IsGrouped') && (data.fields[i] !== 'IsExportedServiceBox')">
                                {{labelFunction(dataItem, data.fields[i])}}
                            </div>

                            <div title="{{ dataItem[ data.fields[i] ] | customPipe: data.format[i]}}"
                                *ngIf="(data.fields[i].indexOf(';') == -1)  && (data.fields[i] != 'IsIntegratedEQ0093') && (data.fields[i] !== 'IsGrouped') && (data.fields[i] !== 'IsExportedServiceBox')">
                                <!-- Se añade condicion en facturacion oper para or a facturar que muestra en caso de que tuvieran comentarios para vehiculos y clientes-->
                                <ng-container *ngIf="dataItem.CarNote || dataItem.CustomerNote; else standardField">
                                    <ng-container [ngSwitch]="i">
                                        <span>{{ dataItem[ data.fields[i] ] | customPipe: data.format[i] }}</span>
                                        <ng-container *ngSwitchCase="1">
                                            <span [popover]="popoverCarNote" [popoverOnHover]="true" popoverPlacement="left" *ngIf="dataItem.CarNote && dataItem.CarNote.trim() != ''">📝</span>
                                            <popover-content #popoverCarNote>
                                                <span style="color: black!important">{{dataItem.CarNote}}</span>
                                            </popover-content>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="5">
                                            <span [popover]="popoverCustomerNote" [popoverOnHover]="true" popoverPlacement="left" *ngIf="dataItem.CustomerNote && dataItem.CustomerNote.trim() != ''">📝</span>
                                            <popover-content #popoverCustomerNote>
                                                <span style="color: black!important">{{dataItem.CustomerNote}}</span>
                                            </popover-content>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <ng-template #standardField>
                                    {{ dataItem[ data.fields[i] ] | customPipe: data.format[i] }}
                                </ng-template>

                            </div>

                            <div class="d-flex align-items-center justify-content-center"
                                *ngIf="data.fields[i] === 'IsIntegratedEQ0093' ||  data.fields[i] === 'IsExportedServiceBox'">
                                <span
                                    [ngClass]="{'circulo-verde': dataItem[ data.fields[i] ],'circulo-gris': !dataItem[ data.fields[i] ]}">
                                </span>
                            </div>

                            <div class="content-icon" *ngIf="data.fields[i] === 'IsGrouped'">
                                <span dspanta-toggle="tooltip" data-placement="right"
                                    title="{{ 'facturas.facturas_operaciones.isGrouped' | translate }}"
                                    [ngClass]="{'k-icon k-i-aggregate-fields': dataItem.IsGrouped }">
                                </span>
                            </div>
                        </ng-template>

                    </kendo-grid-column>

                    <kendo-grid-messages pagerOf="{{ 'genericos.messagesKendo.of' | translate }}"
                        pagerItemsPerPage="{{ 'genericos.messagesKendo.ElementosPagina' | translate }}"
                        pagerItems="{{ 'genericos.messagesKendo.ElementosMostrados' | translate }}">
                    </kendo-grid-messages>

                    <ng-template *ngIf="hasPage" id="pagerTemplate" kendoPagerTemplate let-totalPages="totalPages"
                        let-currentPage="currentPage">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-numeric-buttons [buttonCount]="buttonCount"></kendo-pager-numeric-buttons>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        <kendo-pager-page-sizes [pageSizes]="_globalsService.getPageSizeList()"></kendo-pager-page-sizes>
                        <kendo-pager-info> </kendo-pager-info>
                    </ng-template>

                </kendo-grid>


            </ng-template>
        </kendo-tabstrip-tab>


    </kendo-tabstrip>

    <div *ngIf="isLoading" class="kendo-loading" [style.height.px]="dataTable[0].height">
        <span appCurrentColor class="k-icon k-i-loading small"></span>
    </div>

</div>

<!-- Una Sola Tabla -->
<div *ngIf="dataTable.length <= 1" class="mt-1 tableBox">

    <kendo-grid *ngIf="!isLoading" [resizable]="resizable" [data]="dataTable[0].gridView"
        (cellClick)="selectRow($event)" [pageSize]="pageSize" [skip]="skip" [pageable]="pageable"
        height="{{dataTable[0].height}}" [selectable]="selectable" (pageChange)="pageChange($event)"
        [sortable]="sortable" [sort]="sort" (sortChange)="sortChange($event)"
        [rowClass]="rowCallback">

        <kendo-grid-column *ngFor="let th of dataTable[0].th;let i=index" field="{{dataTable[0].fields[i]}}"
            title="{{ th | translate }}" width="{{dataTable[0].width[i]}}" format="{{dataTable[0].format[i]}}"
            [minResizableWidth]="30">
            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                <span data-toggle="tooltip" data-placement="top" title="{{ th | translate }}">{{th | translate}}
                </span>
            </ng-template>

            <ng-template kendoGridCellTemplate let-dataItem let-column="column">

                <div title="{{ labelFunction(dataItem, dataTable[0].fields[i])}}"
                    *ngIf="(dataTable[0].fields[i].indexOf(';') != -1) && (dataTable[0].fields[i] !== 'iconVOExpedientPOCostList')">
                    {{labelFunction(dataItem, dataTable[0].fields[i])}}
                </div>

                <ng-container *ngIf="(dataTable[0].fields[i].indexOf(';') == -1) && (dataTable[0].fields[i] !== 'iconVOExpedientPOCostList')">
                    <ng-container *ngIf="i == 0 && dataItem.Comment; else ElseBlock">
                        <div title="{{dataTable[0].format[i] === 'boolean-icons-only-check' || dataTable[0].format[i] === 'boolean-icons' ? '' : dataItem[ dataTable[0].fields[i] ] | customPipe: dataTable[0].format[i]}}">
                             {{ dataItem[ dataTable[0].fields[i] ] | customPipe: dataTable[0].format[i] }}
                            <span [popover]="popoverComment" [popoverOnHover]="true" popoverPlacement="right">📝</span>
                        </div>
                        <popover-content #popoverComment>
                            {{dataItem.Comment}}
                        </popover-content>
                    </ng-container>
                    <ng-template #ElseBlock>
                        <div title="{{dataTable[0].format[i] === 'boolean-icons-only-check' || dataTable[0].format[i] === 'boolean-icons' ? '' : dataItem[ dataTable[0].fields[i] ] | customPipe: dataTable[0].format[i]}}"
                             [innerHTML]="dataItem[ dataTable[0].fields[i] ] | customPipe: dataTable[0].format[i]">
                            <!-- {{ dataItem[ dataTable[0].fields[i] ] | customPipe: dataTable[0].format[i] }} -->
                        </div>
                    </ng-template>
                </ng-container>


                <div class="d-flex align-items-center justify-content-center"
                    *ngIf="dataTable[0].fields[i] === 'iconVOExpedientPOCostList'">
                    <span class="k-icon k-i-redo" (click)="redireccionarOR(dataItem)">
                    </span>
                </div>
            </ng-template>
        </kendo-grid-column>

        <ng-template *ngIf="hasPage" id="pagerTemplate" kendoPagerTemplate let-totalPages="totalPages"
            let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="buttonCount"></kendo-pager-numeric-buttons>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="_globalsService.getPageSizeList()"></kendo-pager-page-sizes>
            <kendo-pager-info> </kendo-pager-info>
        </ng-template>

        <kendo-grid-messages pagerOf="{{ 'genericos.messagesKendo.of' | translate }}"
            pagerItemsPerPage="{{ 'genericos.messagesKendo.ElementosPagina' | translate }}"
            pagerItems="{{ 'genericos.messagesKendo.ElementosMostrados' | translate }}">
        </kendo-grid-messages>

        <ng-template kendoGridNoRecordsTemplate>
            <p class="text-center p-2" [style.height.px]="dataTable[0].height">
                {{'gestion_vehiculos.noData' | translate}}
            </p>
        </ng-template>

    </kendo-grid>

    <div class="kendo-loading" *ngIf="isLoading" [style.height.px]="dataTable[0].height">
        <span appCurrentColor class="k-icon k-i-loading big"></span>
    </div>

</div>
